import axiosIns from '@/libs/axios'
import { objectToUrlParam } from '@/libs/helper'

export default class bonusApis {
  verfyCode = async data => await axiosIns.post('/bonus/check-code', data);
}
